import type { ColGroupDef } from 'ag-grid-enterprise'

import { globalDefs } from './columns/global'
import { hintsDefs } from './columns/hints'
import { mwmAdsArpuDefs } from './columns/mwm-ads-arpu'
import { mwmAdsEltvDefs } from './columns/mwm-ads-eltv'
import { mwmArpuDefs } from './columns/mwm-arpu'
import { mwmCostPerUserDefs } from './columns/mwm-cost-per-user'
import { mwmDataPerInstallDefs } from './columns/mwm-data-per-install'
import { mwmEltvDefs } from './columns/mwm-eltv'
import { mwmIapArpuDefs } from './columns/mwm-iap-arpu'
import { mwmIapEltvDefs } from './columns/mwm-iap-eltv'
import { mwmNbUsersDefs } from './columns/mwm-nb-users'
import { mwmRetentionDefs } from './columns/mwm-retention'
import { mwmRevenuePerUserDefs } from './columns/mwm-revenue-per-user'
import { networkDefs } from './columns/network'
import { uaAdsEltvDefs } from './columns/ua-ads-eltv'
import { uaEltvDefs } from './columns/ua-eltv'
import { uaEroiEuroDefs } from './columns/ua-eroi-euro'
import { uaEroiPercentDefs } from './columns/ua-eroi-percent'
import { uaIapEltvDefs } from './columns/ua-iap-eltv'
import { uaIapEltvSovDefs } from './columns/ua-iap-eltv-sov'

export const baseColumnsDefs: ColGroupDef[] = [
  hintsDefs,
  globalDefs,
  uaEltvDefs,
  uaIapEltvDefs,
  uaIapEltvSovDefs,
  uaAdsEltvDefs,
  uaEroiEuroDefs,
  uaEroiPercentDefs,
  networkDefs,
  mwmRetentionDefs,
  mwmArpuDefs,
  mwmIapArpuDefs,
  mwmAdsArpuDefs,
  mwmEltvDefs,
  mwmIapEltvDefs,
  mwmAdsEltvDefs,
  mwmNbUsersDefs,
  mwmDataPerInstallDefs,
  mwmCostPerUserDefs,
  mwmRevenuePerUserDefs,
]
